// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PriceTrackerSummary__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PriceTrackerSummary/PriceTrackerSummary.scss
 ** module id = 930
 ** module chunks = 1
 **/